import { render, staticRenderFns } from "./comp_bg.vue?vue&type=template&id=932912f8&scoped=true"
import script from "./comp_bg.vue?vue&type=script&lang=js"
export * from "./comp_bg.vue?vue&type=script&lang=js"
import style0 from "./comp_bg.vue?vue&type=style&index=0&id=932912f8&prod&lang=scss&scoped=true"
import style1 from "./comp_bg.vue?vue&type=style&index=1&id=932912f8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "932912f8",
  null
  
)

export default component.exports